<template>
    <div class="col-lg-12 d-flex flex-column">
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
        </div>
        <div v-if="!pageloader" class="pb-5">
            <!-- display empty card with no videos found messgae if there are no videos -->
            <div class="row no-gutters" v-if="savedTeamVideoLink === null && savedOfficeVideoLink===null && savedCompanyEventVideoLink === null && savedEmployeeExperienceVideoLink === null">
                <div class="col-12 card mb-4 introvideocard">
                    <div class="row no-gutters p-2" >
                        <div class="col p-5 text-center">
                        <img src="../../assets/no_video.svg" class="img-md-fluid img-sm-fluid no-video mx-auto pb-4" alt="novideo">
                        <div class="col d-flex justify-content-center fontsize16 black60 proximanova">No Video's Found</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- if videos are present -->
            <div v-else>
                <div class="row no-gutters">
                    <!-- team video card -->
                    <div class="col-12 mb-4 shadow introvideocard"  v-if="savedTeamVideoLink">
                        <div class="card overlay-gradient">
                            <div>
                                <video height="300" oncontextmenu="return false" :src="savedTeamVideoLink" @ended="onenddisplayreplayIcon('TEAM')" @waiting="displayLoadingLogo('TEAM')" @canplay="stopLoadingLogo('TEAM')" controlsList="nodownload"  id="teamVideo" ></video>
                            </div>
                            <div class="card-img-overlay ">
                                <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1 borderradius10">
                                <div class="col ml-0 mt-3 d-flex videoheadsection">
                                    <img src="../../assets/VideoProfile.svg" class="img-fluid" alt="videoprofile" />
                                    <div class="d-flex flex-column">
                                    <span class="ml-2 mr-2 proximanova-semibold fontsize16 white">Team Video</span>
                                    <span class="ml-2 mr-2 proximanova fontsize14 white">{{savedTeamVideoDate | moment("ll") }}</span>
                                    </div>
                                </div>
                                </div>
                                <div class="mt-3">
                                    <img src="../../assets/play_video.svg" v-if="!playingTeamVideo" class="playpausevideobtn" alt="playvideo" @click="playTeamVideo">
                                    <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingTeamVideo && replayTeamVideo">
                                        <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo('TEAM')">
                                    </div>
                                    <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingTeamVideo && loadingTeamVideo">
                                        <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                                    </div>
                                    <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="playingTeamVideo && !replayTeamVideo && !loadingTeamVideo" alt="pausevideo" @click="playTeamVideo">
                                </div>
                                <div class="bottom">
                                    <div class="companyvid_overlay2">
                                        <div class="black_overlay_height"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pb-3 cardInfoSection">
                            <div class="d-flex">
                                <div class="mt-3 mb-3 ml-2">
                                    <label class="fontsize16 black stylebold proximanova">Team</label> <br>
                                    <span v-if="savedTeamVideoDescription" class="fontsize14 black60 proximanova text-capitalize">{{savedTeamVideoDescription}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- office video card -->
                    <div class="col-12 mb-4 shadow introvideocard"  v-if="savedOfficeVideoLink">
                        <div class="card overlay-gradient">
                            <div>
                                <video height="300" oncontextmenu="return false" :src="savedOfficeVideoLink" @ended="onenddisplayreplayIcon('OFFICE')" @waiting="displayLoadingLogo('OFFICE')" @canplay="stopLoadingLogo('OFFICE')" controlsList="nodownload"  id="officeVideo" ></video>
                            </div>
                            <div class="card-img-overlay ">
                                <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1 borderradius10">
                                <div class="col ml-0 mt-3 d-flex videoheadsection">
                                    <img src="../../assets/VideoProfile.svg" class="img-fluid" alt="videologo" />
                                    <div class="d-flex flex-column">
                                        <span class="ml-2 mr-2 proximanova-semibold fontsize16 white">Office Video</span>
                                        <span class="ml-2 mr-2 proximanova fontsize14 white">{{savedOfficeVideoDate | moment("ll") }}</span>
                                    </div>
                                </div>
                                </div>
                                <div class="mt-3">
                                <img src="../../assets/play_video.svg" v-if="!playingOfficeVideo" class="playpausevideobtn" alt="playvideo" @click="playOfficeVideo">
                                <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingOfficeVideo && replayOfficeVideo">
                                    <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo('OFFICE')">
                                </div>
                                <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingOfficeVideo && loadingOfficeVideo">
                                    <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                                </div>
                                <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="playingOfficeVideo && !replayOfficeVideo && !loadingOfficeVideo" alt="pausevideo" @click="playOfficeVideo">
                                </div>
                                <div class="bottom">
                                    <div class="companyvid_overlay2">
                                        <div class="black_overlay_height"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pb-3 cardInfoSection">
                            <div class="d-flex">
                                <div class="mt-3 mb-3 ml-2">
                                    <label class="fontsize16 black stylebold proximanova">Office Space</label> <br>
                                    <span v-if="savedOfficeVideoDescription" class="fontsize14 black60 proximanova text-capitalize">{{savedOfficeVideoDescription}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row no-gutters">
                    <!-- company events video card -->
                    <div class="col-12 mb-4 shadow introvideocard"  v-if="savedCompanyEventVideoLink">
                        <div class="card overlay-gradient">
                            <div>
                                <video height="300" oncontextmenu="return false" :src="savedCompanyEventVideoLink" @ended="onenddisplayreplayIcon('COMPANY')" @waiting="displayLoadingLogo('COMPANY')" @canplay="stopLoadingLogo('COMPANY')" controlsList="nodownload"  id="companyEventVideo" ></video>
                            </div>
                            <div class="card-img-overlay ">
                                <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1 borderradius10">
                                <div class="col ml-0 mt-3 d-flex videoheadsection">
                                    <img src="../../assets/VideoProfile.svg" class="img-fluid" alt="videoimg" />
                                    <div class="d-flex flex-column">
                                    <span class="ml-2 mr-2 proximanova-semibold fontsize16 white">Company Event Video</span>
                                    <span class="ml-2 mr-2 proximanova fontsize14 white">{{savedCompanyEventVideoDate | moment("ll") }}</span>
                                    </div>
                                </div>
                                </div>
                                <div class="mt-3">
                                <img src="../../assets/play_video.svg" v-if="!playingCompanyEventVideo" class="playpausevideobtn" alt="playvideo" @click="playCompanyEventVideo">
                                <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingCompanyEventVideo && replayCompanyEventVideo">
                                    <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo('COMPANY')">
                                </div>
                                <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingCompanyEventVideo && loadingCompanyEventVideo">
                                    <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                                </div>
                                <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="playingCompanyEventVideo && !replayCompanyEventVideo && !loadingCompanyEventVideo" alt="pausevideo" @click="playCompanyEventVideo">
                                </div>
                                <div class="bottom">
                                    <div class="companyvid_overlay2">
                                        <div class="black_overlay_height"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pb-3 cardInfoSection">
                            <div class="d-flex">
                                <div class="mt-3 mb-3 ml-2">
                                    <label class="fontsize16 black stylebold proximanova">Company Evenets</label> <br>
                                    <span v-if="savedCompanyEventVideoDescription" class="fontsize14 black60 proximanova text-capitalize">{{savedCompanyEventVideoDescription}}</span>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <!-- employee experience video card -->
                    <div class="col-12 mb-4 shadow introvideocard" v-if="savedEmployeeExperienceVideoLink">
                        <div class="card overlay-gradient" >
                            <div>
                                <video height="300" oncontextmenu="return false" :src="savedEmployeeExperienceVideoLink" @ended="onenddisplayreplayIcon('EXPERIENCE')" @waiting="displayLoadingLogo('EXPERIENCE')" @canplay="stopLoadingLogo('EXPERIENCE')" controlsList="nodownload"  id="employeeexperienceVideo" ></video>
                            </div>
                            <div class="card-img-overlay ">
                                <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1 borderradius10">
                                <div class="col ml-0 mt-3 d-flex videoheadsection">
                                    <img src="../../assets/VideoProfile.svg" class="img-fluid" alt="videoimg"/>
                                    <div class="d-flex flex-column">
                                        <span class="ml-2 mr-2 proximanova-semibold fontsize16 white">Employee Experience Video</span>
                                        <span class="ml-2 mr-2 proximanova fontsize14 white">{{savedEmployeeExperienceVideoDate | moment("ll") }}</span>
                                    </div>
                                </div>
                                </div>
                                <div class="mt-3">
                                <img src="../../assets/play_video.svg" v-if="!playingEmployeeExperienceVideo" class="playpausevideobtn" alt="playvideo" @click="playEmployeeExperieneceVideo">
                                <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingEmployeeExperienceVideo && replayEmployeeExperienceVideo">
                                    <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo('EXPERIENCE')">
                                </div>
                                <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingEmployeeExperienceVideo && loadingEmployeeExperienceVideo">
                                    <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                                </div>
                                <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="playingEmployeeExperienceVideo && !replayEmployeeExperienceVideo && !loadingEmployeeExperienceVideo" alt="pausevideo" @click="playEmployeeExperieneceVideo">
                                </div>
                                <div class="bottom">
                                    <div class="companyvid_overlay2">
                                        <div class="black_overlay_height"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pb-3 cardInfoSection">
                            <div class="d-flex">
                                <div class="mt-3 mb-3 ml-2">
                                    <label class="fontsize16 black stylebold proximanova">Employee Experience</label> <br>
                                    <span v-if="savedEmployeeExperienceVideoDescription" class="fontsize14 black60 proximanova text-capitalize">{{savedEmployeeExperienceVideoDescription}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import $ from 'jquery'
export default{
    data(){
        return{
            pageloader  :true,
            businessAccountId : null,
            companyprofileId : null,
            addintrovideoimage : require('../../assets/Create_Video.svg'),
            //team video
            playingTeamVideo : false,
            replayTeamVideo : false,
            loadingTeamVideo : false,
            savedTeamVideoId : null,
            savedTeamVideoLink : null,
            savedTeamVideoDate : null,
            savedTeamVideoDescription : null,
            //office Video
            playingOfficeVideo : false,
            replayOfficeVideo : false,
            loadingOfficeVideo : false,
            savedOfficeVideoId : null,
            savedOfficeVideoLink : null,
            savedOfficeVideoDate : null,
            savedOfficeVideoDescription : null,
            //company events Video
            playingCompanyEventVideo : false,
            replayCompanyEventVideo : false,
            loadingCompanyEventVideo : false,
            savedCompanyEventVideoId : null,
            savedCompanyEventVideoLink : null,
            savedCompanyEventVideoDate : null,
            savedCompanyEventVideoDescription : null,
            //Employee experiences Video
            playingEmployeeExperienceVideo : false,
            replayEmployeeExperienceVideo : false,
            loadingEmployeeExperienceVideo : false,
            savedEmployeeExperienceVideoId : null,
            savedEmployeeExperienceVideoLink : null,
            savedEmployeeExperienceVideoDate : null,
            savedEmployeeExperienceVideoDescription : null,
        }
    },
    components: {
    },
    methods :{
        // Fetching Videos data
        getTeamVideo() {
            httpuserprofile.get('/userprofile/getCompanyVideosList?companyProfileId='+this.companyprofileId+'&businessAccountId='+this.businessAccountId+'&videoType=TEAM')
            .then((response) => {
                this.pageloader = false;
                if(response.data.length > 0){
                    this.savedTeamVideoId = response.data[0].videoId;
                    this.savedTeamVideoLink = response.data[0].videoLink;
                    this.savedTeamVideoDescription = response.data[0].description;
                    this.savedTeamVideoDate = response.data[0].creationD
                }
            }).catch((e) => {
                this.pageloader = false;
                console.log(e)
            })
        },
        getOfficeVideo() {
            httpuserprofile.get('/userprofile/getCompanyVideosList?companyProfileId='+this.companyprofileId+'&businessAccountId='+this.businessAccountId+'&videoType=OFFICE')
            .then((response) => {
                this.pageloader = false;
                if(response.data.length > 0){
                    this.savedOfficeVideoId = response.data[0].videoId;
                    this.savedOfficeVideoLink = response.data[0].videoLink;
                    this.savedOfficeVideoDescription = response.data[0].description;
                    this.savedOfficeVideoDate = response.data[0].creationD
                }
            }).catch((e) => {
                this.pageloader = false;
                console.log(e)
            })
        },
        getCompanyVideo() {
            httpuserprofile.get('/userprofile/getCompanyVideosList?companyProfileId='+this.companyprofileId+'&businessAccountId='+this.businessAccountId+'&videoType=COMPANY')
            .then((response) => {
                this.pageloader = false;
                if(response.data.length > 0){
                    this.savedCompanyEventVideoId = response.data[0].videoId;
                    this.savedCompanyEventVideoLink = response.data[0].videoLink;
                    this.savedCompanyEventVideoDescription = response.data[0].description;
                    this.savedCompanyEventVideoDate = response.data[0].creationD
                }
            }).catch((e) => {
                this.pageloader = false;
                console.log(e)
            })
        },
        getExployeeExperienceVideo() {
            httpuserprofile.get('/userprofile/getCompanyVideosList?companyProfileId='+this.companyprofileId+'&businessAccountId='+this.businessAccountId+'&videoType=EXPERIENCE')
            .then((response) => {
                this.pageloader = false;
                if(response.data.length > 0){
                    this.savedEmployeeExperienceVideoId = response.data[0].videoId;
                    this.savedEmployeeExperienceVideoLink = response.data[0].videoLink;
                    this.savedEmployeeExperienceVideoDescription = response.data[0].description;
                    this.savedEmployeeExperienceVideoDate = response.data[0].creationD
                }
            }).catch((e) => {
                this.pageloader = false;
                console.log(e)
            })
        },
        // this will invoke after click on play/pause button on team video card to play/pause the video
        playTeamVideo : function() {
            var teamvideo = document.getElementById('teamVideo')
            if(!this.playingTeamVideo) {
                this.playingTeamVideo = true
                teamvideo.play()
                this.pauseOtherVideos('TEAM')
            }else{
                this.playingTeamVideo = false;
                teamvideo.pause()
            }
        },
         // this will invoke after click on play/pause button on office video card to play/pause the video
        playOfficeVideo : function() {
            var officevideo = document.getElementById('officeVideo')
            if(!this.playingOfficeVideo) {
                this.playingOfficeVideo = true
                officevideo.play()
                this.pauseOtherVideos('OFFICE')
            }else{
                this.playingOfficeVideo = false;
                officevideo.pause()
            }
        },
        // this will invoke after click on play/pause button on company video card to play/pause the video
        playCompanyEventVideo : function() {
            var companyvideo = document.getElementById('companyEventVideo')
            if(!this.playingCompanyEventVideo) {
                this.playingCompanyEventVideo = true
                companyvideo.play()
                this.pauseOtherVideos('COMPANY')
            }else{
                this.playingCompanyEventVideo = false;
                companyvideo.pause()
            }
        },
        // this will invoke after click on play/pause button on employee experience video card to play/pause the video
        playEmployeeExperieneceVideo : function() {
            var employeeexperiencevideo = document.getElementById('employeeexperienceVideo')
            if(!this.playingEmployeeExperienceVideo) {
                this.playingEmployeeExperienceVideo = true
                employeeexperiencevideo.play()
                this.pauseOtherVideos('EXPERIENCE')
            }else{
                this.playingEmployeeExperienceVideo = false;
                employeeexperiencevideo.pause()
            }
        },
        // this will invoke after play any particular video to pause another videos
        pauseOtherVideos(videoType){
            var teamvideo = document.getElementById('teamVideo')
            var officevideo = document.getElementById('officeVideo')
            var companyvideo = document.getElementById('companyEventVideo')
            var employeeexperiencevideo = document.getElementById('employeeexperienceVideo')
            if(videoType !== 'TEAM' && teamvideo){
                if(!this.replayTeamVideo) {
                this.playingTeamVideo = false;
                }
                teamvideo.pause()
            }
            if(videoType !== 'COMPANY' && companyvideo){
                if(!this.replayCompanyEventVideo) {
                this.playingCompanyEventVideo = false;
                }
                companyvideo.pause()
            }
            if(videoType !== 'OFFICE' && officevideo){
                if(!this.replayOfficeVideo) {
                this.playingOfficeVideo = false;
                }
                officevideo.pause()
            }
            if(videoType !== 'EXPERIENCE' && employeeexperiencevideo){
                if(!this.replayEmployeeExperienceVideo) {
                this.playingEmployeeExperienceVideo = false;
                }
                employeeexperiencevideo.pause()
            }
        },
        onenddisplayreplayIcon(type) {
            if(type == 'TEAM'){
                console.log("team")
                this.replayTeamVideo = true;
                this.loadingTeamVideo = false;
            }else if(type == 'COMPANY') {
                console.log("company")
                this.replayCompanyEventVideo = true;
                this.loadingCompanyEventVideo = false;
            }else if(type == 'OFFICE') {
                console.log("office")
                this.replayOfficeVideo = true;
                this.loadingOfficeVideo = false;
            }else if(type == 'EXPERIENCE') {
                console.log("experienece")
                this.replayEmployeeExperienceVideo = true;
                this.loadingEmployeeExperienceVideo = false;
            }
        },
        displayLoadingLogo(type) {
            if(type == 'TEAM'){
                console.log("team loading")
                if(this.playingTeamVideo){
                    this.loadingTeamVideo = true;
                }
            }else if(type == 'COMPANY') {
                console.log("company loading")
                if(this.playingCompanyEventVideo){
                    this.loadingCompanyEventVideo = true;
                }
            }else if(type == 'OFFICE') {
                console.log("office loading")
                if(this.playingOfficeVideo){
                    this.loadingOfficeVideo = true;
                }
            }else if(type == 'EXPERIENCE') {
                console.log("experienece loading")
                if(this.playingEmployeeExperienceVideo){
                    this.loadingEmployeeExperienceVideo = true;
                }
            }
        },
        stopLoadingLogo(type) {
            if(type == 'TEAM'){
                console.log("team stop loading")
                if(this.playingTeamVideo){
                    this.loadingTeamVideo = false;
                }
            }else if(type == 'COMPANY') {
                console.log("company stop loading")
                if(this.playingCompanyEventVideo){
                    this.loadingCompanyEventVideo = false;
                }
            }else if(type == 'OFFICE') {
                console.log("office stop loading")
                if(this.playingOfficeVideo){
                    this.loadingOfficeVideo = false;
                }
            }else if(type == 'EXPERIENCE') {
                console.log("experienece stop loading")
                if(this.playingEmployeeExperienceVideo){
                    this.loadingEmployeeExperienceVideo = false;
                }
            }
        },
        replayVideo(type) {
            if(type == 'TEAM'){
                console.log("team replay")
                this.replayTeamVideo = false;
                this.playingTeamVideo = false;
                this.playTeamVideo()
            }else if(type == 'COMPANY') {
                console.log("company replay")
                this.replayCompanyEventVideo = false;
                this.playingCompanyEventVideo = false;
                this.playCompanyEventVideo()
            }else if(type == 'OFFICE') {
                console.log("office replay")
                this.replayOfficeVideo = false;
                this.playingOfficeVideo = false;
                this.playOfficeVideo()
            }else if(type == 'EXPERIENCE') {
                console.log("experienece replay")
                this.replayEmployeeExperienceVideo = false;
                this.playingEmployeeExperienceVideo = false;
                this.playEmployeeExperieneceVideo()
            }
        }
    },
    mounted(){
        this.businessAccountId = this.$session.get("business_account_id")
        this.companyprofileId = this.$session.get("company_profile_id")
        // fetching videos
        this.getTeamVideo()
        this.getOfficeVideo()
        this.getCompanyVideo()
        this.getExployeeExperienceVideo()
    }
}
</script>
<style scoped>
/* video card styles */
.introvideocard{
  padding-left: 0;
  padding-right: 0;
  border-radius: 10px;
}
.pausebtn{
  display: none;
}
.introvideocard:hover .pausebtn{
  display: block;
  margin-top: 7% !important;
}
.card{
    border-radius: 15px;
}
.card-img-overlay{
  padding: 0;
}
.overlay-gradient{
    border: none;
}
.pageloader{
  width: 10%;
  margin-left: 45%;
  margin-top: 5%;
}
.videoheadsection {
  padding-left: 8px !important;
  padding-right: 0px !important;
}
.postvideomenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.postvideomenu.dropdown-position-bottom {
  left: unset !important;
  top: 35px !important;
  width: 150px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-70%, 10px, 10px) !important;
}
.playpausevideobtn{
  margin-left: 46%;
  margin-top: 5%;
  cursor: pointer;
}
.cardInfoSection{
    background: white;
    border-radius: 0 0 10px 10px;
}
#teamVideo{
  width: 100%;
}
#officeVideo{
    width: 100%;
}
#companyEventVideo{
    width: 100%;
}
#employeeexperienceVideo{
    width: 100%;
}
.bottom{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.closebtnmouseover{
  padding-left: 6px;
  padding-right: 2px;
  margin-top: -4px;
  border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.closebtn {
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;
}
/* details card styles */
.aboutUsDetailsCard{
  border-radius: 10px;
}
.col-12{
    flex: none !important;
}
a:hover{
  color: #007AFF !important;
}
#playvideobtn {
    display: block;
    margin-left: 47%;
    margin-top: 8% !important;
    margin-bottom: 5%;
    cursor: pointer;
}
@media only screen and (max-width: 600px){
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
}
</style>
